import styled from "styled-components";

export const Container = styled.main`
    display: grid;
    grid-template-columns: 0px auto;
    grid-template-areas: 'AS CT';
    height: 100vh;
`;

export const Content = styled.div`
  grid-area: CT;
  margin-left: 70px;
  overflow-y: auto;
  
  @media (max-width: 900px) {
    margin-left: 0px;
  }
`;
